import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { ReachOverviewStat } from 'api';
import { Queries, DatePickers } from 'components';

import { useDateRange } from 'hooks';

import { AreaChart, TabLabel, IAreaChartConfig, TabbedChartLoader } from '../shared';
import { TABBED_CHART_HEIGHT } from '../constants';
import useStyles from '../analyticsStyles';

const TotalReachOverviewStats: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { startDate, setStartDate, endDate, setEndDate, dateRange, setDateRange } = useDateRange();

  function renderSummaryTabs(queryResults: ReachOverviewStat) {
    const { summary } = queryResults;
    const { reach } = summary;

    return (
      <Grid container>
        <Grid item>
          <Tabs value="reach" classes={{ indicator: classes.hiddenIndicator }}>
            <Tab
              classes={{ root: classes.tabRoot, wrapper: classes.tabWrapper }}
              label={<TabLabel stat={reach} i18nKey="common:total_reach" />}
              value="reach"
            />
          </Tabs>
        </Grid>
      </Grid>
    );
  }

  function renderChart(queryResults: ReachOverviewStat) {
    const { summary, data } = queryResults;

    const config: IAreaChartConfig[] = [
      { name: 'Twitter', dataKey: 'twitter_reach', value: summary.twitter_reach },
      { name: 'LinkedIn', dataKey: 'linkedin_reach', value: summary.linkedin_reach },
    ];

    return <AreaChart height={TABBED_CHART_HEIGHT} data={data} config={config} />;
  }

  return (
    <Fragment>
      <Typography paragraph className={classes.hidden} color="textSecondary" variant="h5">
        {t('analytics:total_reach')}
      </Typography>
      <Paper>
        <Queries.TotalReachOverviewStats
          loader={<TabbedChartLoader type="chartArea" height={TABBED_CHART_HEIGHT} />}
          startDate={startDate}
          endDate={endDate}
        >
          {totalReachOverviewStats => (
            <Fragment>
              {renderSummaryTabs(totalReachOverviewStats)}
              <div className={classes.tabbedChartWrapper}>
                {renderChart(totalReachOverviewStats)}
              </div>
            </Fragment>
          )}
        </Queries.TotalReachOverviewStats>
        <Divider />
        <DatePickers.Range
          dateRange={dateRange}
          startDate={startDate}
          endDate={endDate}
          onSetStart={setStartDate}
          onSetEnd={setEndDate}
          onSetRange={setDateRange}
        />
      </Paper>
    </Fragment>
  );
};

export default TotalReachOverviewStats;
